export default __webpack_public_path__ + "static/media/ic_comment.8efc3c6b20d8ec5f26361f7c1ee26d54.svg";